module.exports = __webpack_public_path__ + "assets/media/3.5ea248c7.wav";